/**
 * The transaction hash a check is actually about.
 *
 * For approximate tx checks (`CheckOutputTypeEnum.TX_APPROXIMATE`) the check runs
 * against the counterparty address, so `address` holds that address and `tx` stays
 * empty until the check resolves. `originalTx` keeps the hash the user submitted,
 * which is what has to be shown meanwhile.
 */
export default function getCheckedHash(item: {
  tx?: string;
  originalTx?: string;
}): string {
  return item.tx || item.originalTx || '';
}
